<ion-split-pane contentId="main">
  <ion-menu side="start" menuId="custom" contentId="main">
    <ion-header>
      <ion-toolbar>
        <ion-menu-toggle>
          <ion-icon name="close-outline"></ion-icon>
        </ion-menu-toggle>
        <ion-title>UPS APPSTORE</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        @for(m of menuItems; track m){

        <ion-menu-toggle>
          <ion-item [routerLink]="m.url" routerDirection="root">
            {{ m.title }}
          </ion-item>
        </ion-menu-toggle>
        }
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>
</ion-split-pane>
